import { StepStatusEnum } from '@enums/step-status.enum';

export const STEP_STATUS_LABEL = {
  [StepStatusEnum.companyCheck]: 'Entreprise',
  [StepStatusEnum.headOfficeCheck]: 'Siège social',
  [StepStatusEnum.activityCheck]: 'Activité',
  [StepStatusEnum.capitalCheck]: 'Capital',
  [StepStatusEnum.responsability]: 'Vos responsabilités',
  [StepStatusEnum.physicalPersonPersonalInfoCheck]: 'Vos données personnelles',
  [StepStatusEnum.physicalPersonContactInfoCheck]: 'Vos coordonnées',
  [StepStatusEnum.physicalPersonEmployedStatusInfoCheck]: 'Votre situation professionnelle',
  [StepStatusEnum.physicalPersonSpouseInfoCheck]: 'Votre conjoint(e)',
  [StepStatusEnum.physicalPersonParentsInfoCheck]: 'Vos Parents',
  [StepStatusEnum.cps]: 'CPS',
  [StepStatusEnum.registeredOfficeChallenge]: 'Domiciliation',
  [StepStatusEnum.registeredOfficeOffer]: 'Offre de domiciliation',
  [StepStatusEnum.registeredOfficeSignature]: 'Conditions de domiciliation',
  [StepStatusEnum.registeredOfficePayment]: 'Paiement de la domiciliation',
  [StepStatusEnum.registeredOfficeEnd]: 'Domiciliation validée'
};
